"use client";
import { useEffect, useState } from 'react';

import { useLanguage } from "@/app/utils/LanguageContext";

import Footer from "@/app/ui/footer";
import { useParams, usePathname } from 'next/navigation';
import Header from "@/app/ui/header";
import HeaderNav from "@/app/ui/headernav";
import "./index.scss";
import { getJockeysRides,getBusinessDate } from "@/app/utils/request/requestList";
import dayjs from "dayjs";
import Remarks from "@/app/ui/Common/remarks";
import { getFOStageResult, getAssetPrefix, getCurrentTimeFormatted, adobeData, getSearchParams, updateMetaTag, MeetingState, mapRaceClassList} from "@/app/utils/Common";
import _ from 'lodash';
import NoInformation from "@/app/ui/Common/NoInformation";
import { pageSet } from "@/app/utils/pageSet";

const regex = /^\d{4}\/\d{2}\/\d{2}$/;
const JockeyRides: React.FC = () => {
  const { state: lang } = useLanguage();
  const [meetings, setMeetings ] = useState([] as any);
  const [raceMeetings, setraceMeetings ] = useState([]);
  const [jockeyStat, setjockeyStat ] = useState([]);
  const [stage, setStage ] = useState(0);
  const [loading, setloading ] = useState(true);
  const [nextRacingDate, setnextRacingDate ] = useState("");
  const [dateTitle, setdateTitle ] = useState("");
  const { t, langCode } = lang;
  const assetPrefix = getAssetPrefix();
  const { racedate } = typeof window !== 'undefined' && getSearchParams(new URLSearchParams(window?.location?.search));

  const [curData, setcurData] = useState("");
  const [curMeeting, setcurMeeting] = useState({} as any);
  const [raceClassList, setraceClassList] = useState([] as any);
  //1: hasData, 2: noinfo
  const [hasData, setHasData] = useState(1);
  useEffect(() => {
    updateMetaTag(langCode, pageSet.jockeysrides);
    adobeData(langCode, "pageview", {
      pageId: "racing/local",
    });
  }, [])

  useEffect(() => {

    getJockeysRides("")
    .then(async (res: any) => {
      if(!res)
      {
        setHasData(2);
        setloading(false);
        return;
      } 
      console.log("getJockeysRides", res)
      let targetMeeting = {} as any;
      let resmeetingRace = [] as any;
      let respmPools = [] as any;
      const format_Date = 'DD/MM/YYYY';
      const resmeeting = res?.commonMeetings?.filter((x:any) => MeetingState("DECLARED").includes(x.status)) || [];
      
      const resjockeyStat = res?.jockeyStat || [];
      let tempDate = "";
      if (racedate && regex.test(racedate)) {
        setcurData(racedate)
        targetMeeting = resmeeting?.find((i:any) => i?.date == racedate?.replaceAll("/", "-"));
        if (!targetMeeting) {
          setloading(false);
          return 
        } else {
          resmeetingRace = targetMeeting?.races || [];
          respmPools = targetMeeting?.pmPools || [];
          setnextRacingDate(dayjs(racedate, 'YYYY-MM-DD').format(format_Date));
        }
        tempDate = racedate?.replaceAll("/", "-");
        setcurMeeting(targetMeeting);
      } else {
        resmeetingRace = resmeeting?.[0]?.races || [];
        respmPools = resmeeting?.[0]?.pmPools || [];
        setnextRacingDate(dayjs(resmeeting?.[0]?.date).format(format_Date));
        tempDate = resmeeting?.[0]?.date;
        setcurData(tempDate.replaceAll("-", "/"))
        targetMeeting = resmeeting?.[0];
        setcurMeeting(targetMeeting);
      }

      getFOStageResult(tempDate, "JKC").then((resStage:any) => {
        setStage(resStage);
      });

      setMeetings(resmeeting);
      setraceMeetings(resmeetingRace);
      // setjockeyStat(resjockeyStat);
      const _tempraceClassList = mapRaceClassList(targetMeeting);
      setraceClassList(_tempraceClassList);
      const notIncludesStatus = ["Standby"];
      const jockeyList = [] as any;
        resmeetingRace?.forEach((ele:any) => {
          ele?.runners?.forEach((ele2:any) => {
            if (!notIncludesStatus.includes(ele2?.status)) {
              const targetJockey = jockeyList.find((i:any) => i?.jockeyCode == ele2?.jockey?.code)
              // new jockey

              const targetWinOdds = respmPools?.find((i:any) => i?.leg?.number == ele?.no)?.oddsNodes?.find((ii:any) => parseInt(ii?.combString) == ele2?.no)?.oddsValue || "";
              
              let HName = "";
              if (!notIncludesStatus.includes(ele2?.status)) {
                HName = lang.langCode == "en-us" ? ele2?.horse?.name_en : ele2?.horse?.name_ch
              }

              if(!targetJockey) {
                jockeyList.push({
                  jockeyCode: ele2?.jockey?.code,
                  jockeyName: lang.langCode == "en-us" ? ele2?.jockey?.name_en: ele2?.jockey?.name_ch,
                  jockeyName_en: ele2?.jockey?.name_en,
                  jockeyHorseList: [{
                    horseName: HName,
                    horseCode: ele2?.horse?.code,
                    HorseID: ele2?.horse?.id,
                    // winOdds: ele2?.winOdds,
                    winOdds: targetWinOdds == "---" ? "" : parseFloat(targetWinOdds),
                    raceNo: ele?.no,
                    status: ele2?.status,
                  }],
                })
              } else {
                targetJockey?.jockeyHorseList?.push({
                  horseName: HName,
                  // winOdds: ele2?.winOdds,
                  winOdds: targetWinOdds == "---" ? "" : parseFloat(targetWinOdds),
                  horseCode: ele2?.horse?.code,
                  HorseID: ele2?.horse?.id,
                  raceNo: ele?.no,
                  status: ele2?.status,
                })
              }
            }
            
          });
        });
        const initStatValue = {
          numFirst: 0,
          numSecond: 0,
          numThird: 0,
          numFourth: 0,
          numFifth: 0,
          numStarts: 0,
        }
        jockeyList.forEach((ele:any) => {
          const tarEle = resjockeyStat?.find((i:any) =>i?.code == ele?.jockeyCode);
          if (tarEle) {
            ele.ssnStat = tarEle?.ssnStat?.find((i:any) => i?.ven == "ALL") || initStatValue;
          }else {
            ele.ssnStat = initStatValue;
          }
          if (tarEle) {
            ele.dhStat = tarEle?.dhStat?.find((x: any) => x?.ven?.toUpperCase() == "ALL") || initStatValue;
          } else {
            ele.dhStat = initStatValue;
          }
        });
        const tempSort = _.orderBy(jockeyList,
          ["ssnStat.numFirst", "dhStat.numFirst",
          "ssnStat.numSecond", "dhStat.numSecond",
          "ssnStat.numThird", "dhStat.numThird",
          "ssnStat.numFourth", "dhStat.numFourth",
          "ssnStat.numFifth", "dhStat.numFifth",
          "ssnStat.numStarts",
          "jockeyName_en"
        ],
        ["desc", "asc",
        "desc", "asc",
        "desc", "asc",
        "desc", "asc",
        "desc", "asc",
        "asc",
        "asc",
        ]) as any
        console.log('【jockeyList-----】', jockeyList)
        setjockeyStat(tempSort);
    })
    .catch((e: any) => {
      console.log(e);
    }).finally(() => {
      setloading(false)
    });
  }, []);

  const handleTitleDate = (date: string) => lang.langCode == "en-us" ?
  `${new Date(date).getDate().toString().padStart(2, '0')} ${new Date(date).toLocaleString(lang.langCode, { month: "short" })}`
  : `${new Date(date).toLocaleString(lang.langCode, { month: "short" })}${new Date(date).getDate()}日 `;

  const handleRaceHeader = () => {
    return meetings?.map((item:any, idx:any) => {
        console.log('[------------item]', item)
        const curDate = handleTitleDate(item?.date);
        let btnClass = '';
        if (racedate && regex.test(racedate)) {
          if (racedate.replaceAll("/", "-") == item?.date){
            btnClass = "blueBtn1";
          }else {
            btnClass = "greyBtn";
          }
        } else {
          btnClass = idx == 0 ? "blueBtn1": "greyBtn"
        }
        return <a key={idx} className={btnClass} href={`/${lang.langCode}/local/info/jockeys-rides?racedate=${item?.date.replaceAll("-", "/")}`} onClick={(event) => {
          if(btnClass =="blueBtn1") event.preventDefault();
        }}> {curDate} - {t(item?.venueCode)}</a>
      })
  }

  const JockeysRideContent = () => {

    if (loading) return null;
    if (hasData == 2) return <NoInformation ssn_end={true} type="noinfo" />
    return meetings?.length ? (<div className="commContent jockeysRides f_fs13">
    <div className="commTitlePic">
    <img src={`${assetPrefix}/images/title_jockeyrides_fullday_${lang?.langCode == "en-us" ? "en" : "cn"}.gif`} />
    </div>
    <div className="date_title f_tar">
    {handleRaceHeader()}
    </div>
    <div id="JKC">
        <div className="data_tab performance fon13" id="JKC_info" style={{width: "920px"}}>
            {
              stage > 2 ?   <div className={`f_tar titleHoverColorPurple`}>
                  <u><a href={`/${lang.langCode}/local/info/jkc-scheduled-rides${curData? `?racedate=${curData}` : ""}`}>{t("JKC_Scheduled_Rides_List")}</a></u>
              </div>: null
            }
            <div className="f_fs13 f_clear">
            {t("Race_Meeting")}: {nextRacingDate}
              {stage > 1 ? 
                  <p className={`f_fr nav titleHoverColorPurple`}>{t("Last_Update_Time")} {getCurrentTimeFormatted()}<span>
                    <a onClick={()=> {window.location.href = window.location.href}} style={{cursor: "pointer"}}>[{t("Refresh")}]</a></span></p>
                  :null
              }
                </div>
              <JockeysRideTable raceClassList={raceClassList} curMeeting={curMeeting}raceMeetings={raceMeetings} jockeyStat={jockeyStat}/>
        </div>
    </div>

    <Remarks path="JockeysRides" customClass="jkc_remark"/>
    <></>
    </div>) : <NoInformation type="willbeavailable" ssn_end={true} PageName={t("pagename_JockeyRides")} DirectPageName={t("pagename_RaceCard")} pageRemark="JockeysRides" /> 
  }
  return <>
      <div id='mainContainer'>
        <Header/>
        <HeaderNav/>              
        <JockeysRideContent />
      </div>
      <Footer />
    </>
};

const JockeysRideTable = (props: any) => {
  const {curMeeting, raceMeetings, jockeyStat, raceClassList} = props;
  const { state: lang } = useLanguage();
  const { t } = lang;

  const renderRaceNoColumn = (No:any) => lang?.langCode == "en-us" ? `Race ${No}`: `第 ${No} 場`
  
  const renderStatus = (raceno:any) => {
    const abandonInd = raceClassList?.find((i:any) => i?.raceNo == raceno )?.AbandonInd;
    if (abandonInd > 1)  return t("Race_Abandoned").replace(" ", "<br/>")
    if (abandonInd > 0)  return t("Race_Voided").replace(" ", "<br/>")
    return ""
  }

  return <table className="margin_top10 table_bd f_tac fon13" style={{width: lang.langCode == "zh-hk" ? "100%": "860px", lineHeight: "120%", border: "1px solid black"}}>
          <thead>
              <tr className="bg_blue font_wb color_w" style={{height: lang.langCode == "zh-hk" ? 20 : "unset"}}>
                  <td style={{ width: lang.langCode == "zh-hk" ? 80 : "unset", verticalAlign: lang.langCode == "zh-hk" ? "bottom" : "unset" }}>{t("jockey")}</td>
                  <td style={{ width: 110, verticalAlign: lang.langCode == "zh-hk" ? "bottom" : "unset" }}>{t("currentSeasonScore")}</td>
                  {raceMeetings.map((race:any, indx:any)=> <th key={indx} className="f_tac bg_blue" style={{width: 70, verticalAlign: lang.langCode == "zh-hk" ? "bottom" : "unset" }}>{renderRaceNoColumn(race?.no)}</th>)
                              }
              </tr>
              <tr className="tdBgYellow tdAlignC f_fs13">
                  <td style={{whiteSpace: "nowrap", padding: "0 3px"}}> {t("Race_Class")}<br />
                      {t("Dist.")}<br />
                      {t("Track")}</td>
                  <td className="tdAlignVC" style={{padding: lang.langCode == "en-us" ? "0 3px" : 0}}>
                      <div style={{display: "table", width: "100%", minWidth : "110px", tableLayout: "fixed"}}>
                          <div className="tdAlignVC" style={{display: "table-cell"}}>{t("1st")}</div>
                          <div className="tdAlignVC" style={{display: "table-cell"}}>{t("2nd")}</div>
                          <div className="tdAlignVC" style={{display: "table-cell"}}>{t("3rd")}</div>
                          <div className="tdAlignVC" style={{display: "table-cell"}} dangerouslySetInnerHTML={{ __html: t("total_Runs") }}></div>
                      </div>
                  </td>
                    { raceMeetings.map((race:any, indx: any)=> {
                      let raceTrack = "";
                      switch (race?.raceTrack?.code) {
                        case "AWT":
                          raceTrack = lang?.langCode == "en-us" ? race?.raceTrack?.code : "全天候";
                          break;
                        default:
                          raceTrack = lang?.langCode == "en-us" ? race.raceTrack.description_en: race.raceTrack.description_ch
                          break;
                      }
                      return <td key={indx} className="R1 tdBgYellow">
                      { race.claCode}<br />
                        {race.distance}{t("Meter")}<br />
                        {raceTrack}<br />
                        <span dangerouslySetInnerHTML={{ __html: renderStatus(race?.no)}}/>
                        </td>
                      })
                              }
              </tr>
          </thead>
          <tbody>
              {
                jockeyStat.map((jockey:any, indx: any)  => {
                
                  return (<tr key={indx}>
                    <td className="tdAlignC f_fs13" style={{ padding: "0 3px"}}>
                        <a href={`/${lang.langCode}/local/information/jockeyprofile?jockeyid=${jockey?.jockeyCode}`}>{jockey?.jockeyName}</a>
                    </td>
                    <td>
                        <div style={{display: "table", width: "100%", minWidth : "110px", tableLayout: "fixed"}}>
                            <div className="tdAlignVC" style={{display: "table-cell"}}>{jockey?.ssnStat?.numFirst || 0}</div>
                            <div className="tdAlignVC" style={{display: "table-cell"}}>{jockey?.ssnStat?.numSecond || 0}</div>
                            <div className="tdAlignVC" style={{display: "table-cell"}}>{jockey?.ssnStat?.numThird || 0}</div>
                            <div className="tdAlignVC" style={{display: "table-cell"}}>{jockey?.ssnStat?.numStarts || 0}</div>
                        </div>
                    </td>
                    {
                      raceMeetings.map((race:any, indx2:any) => {
                        const runner = race?.runners.find((i:any) => i?.jockey?.code == jockey?.jockeyCode)
                        // const horseName = lang?.langCode == "en-us" ? runner?.horse?.name_en: runner?.horse?.name_ch

                        // const ruJ = race?.runners.find((x: any) => !["scratched", "scratchedreserved", "standby"].includes(x.status.toLowerCase())) || {};

                        const changeJockey = curMeeting?.changeHistories?.find((x: any) => x.type == "99" && x.runnerNo == runner?.no && x.raceNo == race?.no && x.horseCode === runner?.horse?.code && x?.dueToPromotion == '0');
                        const hasMultis = jockey?.jockeyHorseList?.filter((i:any) => i.raceNo == race?.no).length > 1;
                        return <td key={indx2}className={!hasMultis && changeJockey ? "tdBgPurple": ""} style={{padding: "0 3px"}}>
                          {
                            jockey?.jockeyHorseList?.map((horse:any, idx:any) => {
                              if (horse?.raceNo != race?.no) return null
                              if (hasMultis && horse?.status == "Scratched") return null

                              return horse?.status == "Scratched" ? <span key={idx} className="color_grey1">{t("SCR")}<br />{horse?.horseName}</span> 
                              : <div key={idx}>
                                {horse?.winOdds > 0 ? <><span className="color_red5">{horse?.winOdds}</span><br /></> : null}
                                <a href={`/${lang.langCode}/local/information/horse?horseid=${horse?.HorseID}`}>{horse?.horseName}</a>
                              </div>
                            })
                          }
                      </td>
                      })
                    }
                
                </tr>)
                })
                  
              }
          </tbody>
        </table>
}
export default JockeyRides;